import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'movementtype',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `movementtype`,
    method: 'get',
    params: queriesParams
  })
}

export function add (movementtype) {
  return request({
    url: 'movementtype',
    method: 'post',
    data: movementtype
  })
}

export function show (id) {
  return request({
    url: `movementtype/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `movementtype/${id}`,
    method: 'patch',
    data
  })
}